import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';

export interface DeskTurn {
  role: 'desk' | 'you';
  text: string;
}

export interface DeskReply {
  text: string;
  suggestions: string[];
  actionLabel: string | null;
  actionPath: string | null;
}

@Injectable({ providedIn: 'root' })
export class DeskService {
  private readonly http = inject(HttpClient);
  readonly open = signal(false);
  readonly startWith = signal<string | null>(null);

  show(): void {
    this.open.set(true);
  }

  askAbout(message: string): void {
    this.startWith.set(message);
    this.open.set(true);
  }

  ask(message: string, earlier: DeskTurn[]): Observable<DeskReply> {
    return this.http.post<DeskReply>('/api/desk/ask', { message, earlier });
  }
}
